"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kinds = exports["default"] = exports.KIND_WHITE_BLUE_BACKGROUND = exports.KIND_PRIMARY = exports.KIND_DANGER = exports.KIND_BLUE_BACKGROUND = void 0;

require("./plink.scss");

var _jsxRuntime = require("react/jsx-runtime");

// TODO : enum ?
var KIND_PRIMARY = 'primary';
exports.KIND_PRIMARY = KIND_PRIMARY;
var KIND_DANGER = 'danger';
exports.KIND_DANGER = KIND_DANGER;
var KIND_BLUE_BACKGROUND = 'blueBackground';
exports.KIND_BLUE_BACKGROUND = KIND_BLUE_BACKGROUND;
var KIND_WHITE_BLUE_BACKGROUND = 'whiteBackground';
exports.KIND_WHITE_BLUE_BACKGROUND = KIND_WHITE_BLUE_BACKGROUND;
var kindClasses = {};
kindClasses[KIND_PRIMARY] = 'is-primary';
kindClasses[KIND_DANGER] = 'is-danger';
kindClasses[KIND_BLUE_BACKGROUND] = 'p-p-blue-background';
kindClasses[KIND_WHITE_BLUE_BACKGROUND] = 'p-p-white-blue-background';
var kinds = Object.keys(kindClasses); // TODO : comment

exports.kinds = kinds;

var PLink = function PLink(_ref) {
  var id = _ref.id,
      className = _ref.className,
      text = _ref.text,
      action = _ref.action,
      kind = _ref.kind;
  var classes = kindClasses[kind !== null && kind !== void 0 ? kind : KIND_PRIMARY]; // console.error(`action:${action}`);
  // console.log(`action.href : ${action.href}, action.clickHandler : ${action.clickHandler}`)

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
    id: id,
    href: action.href
    /* null or not */
    ,
    className: "".concat(!!className ? "".concat(className, " ") : '', "p-link p-bold ").concat(classes),
    onClick: action.clickHandler || false,
    children: text
  });
};

var _default = PLink;
exports["default"] = _default;